import React, { useContext } from 'react';
import I18n from 'i18n-js';

import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { RCButton } from '@reverbdotcom/cadence/components';
import AutoOfferModal from '../../listings/auto_offer_modal';
import SellerListingCardContext from '../SellerListingCardContext';
import refetchCardListing from '../refetchCardListing';

interface IExternalProps {
  listingId: string;
  offerActive: boolean;
}

const initialModalState = {
  open: false,
};

function reducer(state, action) {
  switch (action.type) {
    case 'toggleModalOpen':
      return { ...state, open: !state.open };
  }
}

export const COMPONENT_NAME = 'AutoOfferModalButtonV2';

export default function AutoOfferModalButtonV2({
  listingId,
  offerActive,
}: IExternalProps) {
  const [modalState, dispatch] = React.useReducer(reducer, initialModalState);
  const cardListingContext = useContext(
    SellerListingCardContext,
  );

  function handleClick() {
    dispatch({ type: 'toggleModalOpen' });
    trackEvent({
      eventName: MParticleEventName.ClickedComponent,
      componentName: COMPONENT_NAME,
      listingId,
    });
  }

  return (
    <>
      <RCButton
        variant="tertiary"
        onClick={handleClick}
        fullWidth>
        {offerActive && (I18n.t('discovery.offers.autoOffers.autoOffersDisable'))}
        {!offerActive && (I18n.t('discovery.offers.autoOffers.autoOffersEnable'))}
      </RCButton>

      {modalState.open && (
        <AutoOfferModal
          modalIsOpen
          listingId={listingId}
          onModalClose={() => dispatch({ type: 'toggleModalOpen' })}
          refetchCardListing={() => refetchCardListing(cardListingContext)}
        />
      )}
    </>
  );
}
